module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('h1', [_vm._v("Registrieren")])]), _vm._v(" "), _c('p', [_vm._v("\n        E-Mail-Adresse wird überprüft...\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3cfd6fe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/confirm-email.vue
// module id = 242
// module chunks = 0